import React from "react";
import { StyleSheet, View, Text, Image, TouchableOpacity } from "react-native";

import { MaterialIcons, Entypo } from "@expo/vector-icons";
import uuidv4 from "../utils/uuidv4";
import { useNavigation } from "@react-navigation/core";
import AsyncStorage from "@react-native-async-storage/async-storage";

const ModalTransfer = ({ handleCloseModal, handleCloseWithTransaction }) => {

    return (
        <>
            <View style={styles.headerLeft}>
                <MaterialIcons
                    onPress={handleCloseModal}
                    name="close"
                    size={30}
                    color="black"
                />

                {/* <Entypo
                        name="share"
                        size={30}
                        color="black"
                    /> */}
            </View>

            <View style={styles.container}>
                <Image
                    source={require("../../assets/success.png")}
                    style={styles.image2}
                />
                <Text style={styles.text}>
                    Sua transferência foi realizada com{" "}
                    <Text style={styles.success}>sucesso!</Text>
                    {/* {"\n\n"}O código desta transação é{" "}
              <Text style={styles.success}>txId{uuidv4.generate()}</Text> */}
                </Text>

                <TouchableOpacity
                    onPress={() => {
                        handleCloseWithTransaction();
                    }}
                >
                    <Text
                        style={{
                            fontWeight: "bold",
                            textAlign: "center",
                            fontSize: 12,
                            marginTop: 100,
                            textDecorationLine: "underline",
                            color: "#228c9a",
                            fontSize: 14,
                        }}
                    >
                        VER COMPROVANTE
                    </Text>
                </TouchableOpacity>
                <Image
                    source={require("../../assets/imgs/gpxcoinModal.png")}
                    style={styles.cardCoin}
                />
            </View>


        </>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: "flex-start",
        alignItems: "center",
        padding: "5%",
        marginTop: 35,
    },
    headerLeft: {
        marginTop: 25,
        padding: 15,
        // alignItems: "flex-start",
        flexDirection: "row",
        justifyContent: "space-between",
    },
    headerRight: {
        marginTop: 25,
        padding: 15,
        alignItems: "flex-end",
    },
    image1: { width: "35%", height: "47%", resizeMode: "stretch" },
    image2: { width: 90, height: 90 },
    text: {
        fontSize: 16,
        marginTop: 30,
        textAlign: "center",
    },
    success: {
        fontWeight: "bold",
        color: "#1FBFB5",
    },
    cardCoin: {
        flex: 1,
        width: 300,
        height: 300,
        position: "absolute",
        right: -50,
        bottom: -50,
    },
});

export default ModalTransfer;
